import React from 'react'
import { ToolbarProps, Navigate as navigate } from 'react-big-calendar'

import { Button, ButtonTabs, Icon } from '@clientbase/clientbase-library'
import { Box, IconButton, useMediaQuery } from '@mui/material'

import { theme } from 'styles/theme'

import { EventsCalendar } from '../../CalendarReceivables.interface'
import * as S from './ToolbarCalendar.styles'

type ViewMode = 'calendar' | 'list'

type ToolbarCalendarProps = {
  balanceScheduled: number | false
  viewMode: ViewMode
  onChangeViewMode: (mode: ViewMode) => void
} & ToolbarProps<EventsCalendar, object>

const VIEW_TABS = [
  { label: 'Calendário', value: 'calendar' },
  { label: 'Lista', value: 'list' }
]

const ToolbarCalendar: React.FC<ToolbarCalendarProps> = ({
  onNavigate,
  label,
  viewMode,
  onChangeViewMode
}) => {
  const isMobile = useMediaQuery('(max-width: 600px)', { noSsr: false })

  // pt-br devolve o mes em minuscula ("agosto 2026")
  const monthLabel =
    typeof label === 'string'
      ? `${label.charAt(0).toUpperCase()}${label.slice(1)}`
      : label

  function getPreviousMonthByButton() {
    onNavigate(navigate.PREVIOUS)
  }

  function getNextMonthByButton() {
    onNavigate(navigate.NEXT)
  }

  return (
    <S.Container>
      <S.Wrapper>
        <IconButton
          sx={{ background: 'transparent !important' }}
          onClick={getPreviousMonthByButton}
        >
          <Icon icon="arrowBackIosNew" fontSize="small" />
        </IconButton>
        <Button
          sx={{
            width: isMobile ? '100%' : 250,
            ':hover': {
              filter: 'brightness(1)',
              bgcolor: theme.palette.neutral[800],
              cursor: 'default'
            }
          }}
          buttonSize="lg"
          variantButton="neutral"
        >
          {monthLabel}
        </Button>
        <IconButton
          sx={{ background: 'transparent !important' }}
          onClick={getNextMonthByButton}
        >
          <Icon icon="arrowForwardIos" fontSize="small" />
        </IconButton>
      </S.Wrapper>

      <Box width={isMobile ? '100%' : 'auto'} mt={isMobile ? 2 : 0}>
        <ButtonTabs
          value={viewMode}
          tabs={VIEW_TABS}
          onChange={(_, value) => {
            onChangeViewMode(value as ViewMode)
          }}
        />
      </Box>
    </S.Container>
  )
}

export default ToolbarCalendar
